'use client';
import { ChipButton, ChipCheckbox, ChipRadio, ChipRemovable } from './chips.js';

const ChipComponent = {
    Button: ChipButton,
    Checkbox: ChipCheckbox,
    Radio: ChipRadio,
    Removable: ChipRemovable,
};
ChipComponent.Button.displayName = 'Chip.Button';
ChipComponent.Checkbox.displayName = 'Chip.Checkbox';
ChipComponent.Radio.displayName = 'Chip.Radio';
ChipComponent.Removable.displayName = 'Chip.Removable';

export { ChipComponent as Chip, ChipButton, ChipCheckbox, ChipRadio, ChipRemovable };
